// Hamburger menu for small screens, the signed-in hint ("Sign in" becomes
// "My garage"), and the outbound-click beacon.
import { bindClicks } from '../lib/clicks'
import { bindNavToggle } from '../lib/nav'
import { applySessionHint } from '../lib/session-hint'

applySessionHint()
bindClicks()

document.querySelectorAll<HTMLButtonElement>('[data-nav-toggle]').forEach(bindNavToggle)
